import { Runbook } from '../types';

export function exportRunbookToMarkdown(runbook: Runbook): void {
  let md = `# ${runbook.title}\n`;
  md += `*${runbook.subtitle}*\n\n`;
  md += `**Protocol Code:** ${runbook.code} | **Category:** ${runbook.category.toUpperCase()} | **Commercial Valuation:** $${runbook.price} USD\n\n`;
  md += `> **Operational Directive:** ${runbook.promise}\n\n`;
  md += `**Target Operator:** ${runbook.audience}\n\n`;
  md += `---\n\n`;

  runbook.sections.forEach(sec => {
    md += `## ${sec.heading}\n\n${sec.body}\n\n`;
  });

  md += `---\n\n## Client Communication & Defense Kit\n\n`;
  runbook.faqs.forEach(f => {
    md += `### ${f.q}\n${f.a}\n\n`;
  });

  md += `\n## Direct Distribution Sequence\n\n`;
  runbook.posts.forEach(p => {
    md += `- ${p}\n`;
  });

  md += `\n### Client Direct Email Cadence\n\n`;
  runbook.emails.forEach((em, idx) => {
    md += `#### Touch ${idx + 1}: ${em.subject}\n\n${em.body}\n\n`;
  });

  const blob = new Blob([md], { type: 'text/markdown;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${runbook.slug}.md`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
